<div class="wrapper">
  @if (picturesData?.picturesList?.length?picturesData?.picturesList?.length:picturesData?.pictures?.length) {
    <div
      class="carousel-block"
      >
      @if (!isSideNavEnable) {
        <button
          class="close-button"
          mat-icon-button
          (click)="clearPicturesData()"
          >
          <mat-icon  title="Close">close</mat-icon>
        </button>
      }
      <app-carousel-type-two
        [slidesData]="picturesData?.picturesList?picturesData?.picturesList:picturesData?.pictures"
        class="image-carousel"
        >
        <ng-template let-carouselOption>
          <app-image
            [url]="carouselOption.preview_url"
            />
        </ng-template>
      </app-carousel-type-two>
      <div class="info">
        <div class="heading">{{ picturesData?.bidItemName?picturesData.bidItemName:picturesData?.bid_item?.item }}</div>
        <div class="details">
          <div class="label">COMMENT:</div>
          <div class="value">{{ picturesData?.comment }}</div>
        </div>
      </div>
    </div>
  }

  @if (!isSideNavEnable) {
    <div class="details">
      <div class="header">
        <mat-icon
          class="icon close-icon"
          (click)="closeSidenav()"
          >close
        </mat-icon>
      </div>
      <template #container></template>
    </div>
  }
</div>
